import { createSlice } from "@reduxjs/toolkit";

const setLoading = (state, value) => {
  state.isLoading = value;
};

const setSuccessWithData = (state, data, key) => {
  state.isLoading = false;
  state[key] = data;
};

const setFailure = (state) => {
  state.isLoading = false;
  state.isAuthenticated = false;
};

const cropSlice = createSlice({
  name: "Crop",
  initialState: {
    isLoading: false,

    // farmer: {},
    cropList: [],
    regionList: [],
  },
  reducers: {
    // crops list
    getcropRequest: (state) => setLoading(state, true),
    getcropSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "cropList"),
    getcropFailure: (state) => setLoading(state, false),

    // regions list
    getRegionsRequest: (state) => setLoading(state, true),
    getRegionsSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "regionList"),
    getRegionsFailure: (state) => setLoading(state, false),

    // regions list
    getCropRegionsRequest: (state) => setLoading(state, true),
    getCropRegionsSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "availableCropRegionList"),
    getCropRegionsFailure: (state) => setLoading(state, false),

    // Create region and crop
    createCropRequest: (state) => setLoading(state, true),
    createCropSuccess: (state) => setLoading(state, false),
    createCropFailure: (state) => setLoading(state, false),

    // Create region and crop
    updateRegionRequest: (state) => setLoading(state, true),
    updateRegionSuccess: (state) => setLoading(state, false),
    updateRegionFailure: (state) => setLoading(state, false),
  },
});

export const {
  getcropRequest,
  getcropSuccess,
  getcropFailure,
  getRegionsRequest,
  getRegionsSuccess,
  getRegionsFailure,
  getCropRegionsRequest,
  getCropRegionsSuccess,
  getCropRegionsFailure,
  createCropRequest,
  createCropSuccess,
  createCropFailure,
  updateRegionRequest,
    updateRegionSuccess,
    updateRegionFailure,
} = cropSlice.actions;

export const cropReducerSlice = cropSlice.reducer;
